var exports = {
  "K": "InstanceAnnouncementNagbar.module__icon___RDlHbF",
  "r": "InstanceAnnouncementNagbar.module__solarIcon___RDlHbF",
};

module.exports = exports;
